module.exports = __webpack_public_path__ + "img/mode1_icon.b9c8f89a.png";